/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TriggerInstance,
  TriggerInstance$inboundSchema,
} from "./triggerinstance.js";

export type ListTriggerInstancesResult = {
  /**
   * The trigger instances for the current project.
   */
  triggers: Array<TriggerInstance>;
};

/** @internal */
export const ListTriggerInstancesResult$inboundSchema: z.ZodMiniType<
  ListTriggerInstancesResult,
  unknown
> = z.object({
  triggers: z.array(TriggerInstance$inboundSchema),
});

export function listTriggerInstancesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListTriggerInstancesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListTriggerInstancesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTriggerInstancesResult' from JSON`,
  );
}
